<template>
    <div class="text-xs text-gray-800 bg-yellow-100 rounded-full px-2 py-1">
        Module
    </div>
</template>
